export default "__VITE_ASSET__r4RInOSI__"